// src/components/Header.jsx - Versione moderna con logo aziendale
import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import NotificationCenter from './NotificationCenter';
import AdminNotificationCenter from './Admin/AdminNotificationCenter';
import logoImg from '../assets/Logoaziende.png';
import './Header.css'; // Importa il CSS separato
import HRNotificationCenter from './HR/HRNotificationCenter';

const Header = ({ userRole, isAdminView, onToggleView }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Recupera nome e cognome dal database
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const user = auth.currentUser;
        if (user) {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserData(docSnap.data());
          } else {
            setUserData({ email: user.email });
          }
        }
      } catch (error) {
        console.error("Errore durante il recupero dei dati utente:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("Logout effettuato con successo");
    } catch (error) {
      console.error("Errore durante il logout:", error);
    }
  };

  const handleKioskMode = () => {
    const conferma = window.confirm(
      'Sei sicuro di voler entrare in kiosk mode?\n\n' +
      'Ricorda che devi essere in possesso della password di ingresso e uscita.'
    );
    
    if (conferma) {
      localStorage.setItem('kiosk_mode', 'true');
      window.location.reload();
    }
  };

  const getRoleDisplayName = (role) => {
    switch(role) {
      case 'admin':
        return 'Amministratore';
      case 'responsabile':
        return 'Responsabile';
      case 'hr':
        return 'HR Manager';
        case 'capo_officina':  
        return 'Capo Officina';
      case 'user':
      default:
        return 'Utente';
    }
  };

  // Determina il nome da visualizzare
  const displayName = userData ? 
    (userData.nome && userData.cognome ? 
      `${userData.nome} ${userData.cognome}` : 
      userData.email) : 
    'Caricamento...';

  // Ottieni le iniziali per l'avatar
  const getInitials = () => {
    if (userData?.nome && userData?.cognome) {
      return `${userData.nome.charAt(0)}${userData.cognome.charAt(0)}`.toUpperCase();
    }
    return displayName.charAt(0).toUpperCase();
  };

  return (
    <header className="modern-header">
      <div className="header-container">
        {/* Logo aziendale */}
        <div className="header-logo">
          <img src={logoImg} alt="Logo Aziendale" className="logo-image" />
          <span className="logo-text">App - Gruppo Iacuzzo</span>
        </div>

        {/* Sezione destra con notifiche e utente */}
        <div className="header-actions">
{/* Centro notifiche */}
{userRole === 'admin' || userRole === 'responsabile' ? (
  <AdminNotificationCenter />
) : userRole === 'hr' ? (
  <HRNotificationCenter />
) : (
  <NotificationCenter />
)}

          {/* Pulsanti admin, responsabile e HR */}
          {(userRole === 'admin' || userRole === 'responsabile' || userRole === 'hr' || userRole === 'capo_officina') && (
  <div className="admin-controls">
    {onToggleView && (
      <button
        onClick={onToggleView}
        className="header-btn view-toggle-btn"
        title={isAdminView 
          ? "Passa a vista utente" 
          : (userRole === 'admin' 
              ? "Passa a vista admin" 
              : userRole === 'responsabile' 
                ? "Passa a vista responsabile"
                : userRole === 'hr'
                  ? "Passa a vista HR"
                  : "Passa a vista capo officina")
        }
        aria-label={isAdminView 
          ? "Passa a vista utente" 
          : (userRole === 'admin' 
              ? "Passa a vista admin" 
              : userRole === 'responsabile' 
                ? "Passa a vista responsabile"
                : userRole === 'hr'
                  ? "Passa a vista HR"
                  : "Passa a vista capo officina")
        }
      >
        <span className="btn-text">
        {isAdminView 
  ? '👤 Vista Utente' 
  : (userRole === 'admin' 
      ? '⚙️ Vista Admin' 
      : userRole === 'responsabile' 
        ? '⚙️ Vista Responsabile'
        : userRole === 'hr'
          ? '🟢 Vista HR'
          : '🔧 Pannello Capo Officina')
}
        </span>
      </button>
    )}
    {userRole === 'admin' && (
      <button
        onClick={handleKioskMode}
        className="header-btn kiosk-btn"
        title="Attiva modalità kiosk"
        aria-label="Attiva modalità kiosk"
      >
        <span className="btn-text">🖥️ Kiosk</span>
      </button>
    )}
  </div>
)}


          {/* Menu utente - Solo avatar con iniziali */}
          <div className="user-menu-container">
            <button 
              className="user-menu-trigger"
              onClick={() => setShowUserMenu(!showUserMenu)}
              aria-label="Menu utente"
              title={displayName}
            >
              <div className="user-avatar">
                {getInitials()}
              </div>
            </button>

            {/* Dropdown menu */}
            {showUserMenu && (
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="dropdown-avatar">
                    {getInitials()}
                  </div>
                  <div className="dropdown-user-info">
                    <p className="dropdown-name">{displayName}</p>
                    <p className="dropdown-role">{getRoleDisplayName(userRole)}</p>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <button 
                  onClick={handleLogout}
                  className="dropdown-item logout-btn"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M6 2H2v12h4m4-6H3m7 0l-3-3m3 3l-3 3"/>
                  </svg>
                  Esci
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;